import { ResourceChangeset } from 'core-app/shared/components/fields/changeset/resource-changeset';
import { GridWidgetResource } from 'core-app/features/hal/resources/grid-widget-resource';

export class WidgetChangeset extends ResourceChangeset<GridWidgetResource> {

}
